import { useContext } from 'react';
import AdminContext, { AdminContextProps } from '../context/AdminContext';

const useAdminContext = (): AdminContextProps => useContext(AdminContext);

export default useAdminContext;
